import {ClinicPatientsAppliedFilterDefault, ClinicPatientsAppliedFilters, ClinicPatientsSortRule} from '../../symbols/dashboard-clinic-patients-manage-list.symbols';
import {PROGRESS_STATUSES, UnknownError} from '../../../shared/symbols';
import {UserSharedAccountData} from '../../symbols/dashboard-clinic-patients.symbols';

/** Unique identifier for clinic patients state. */
export const clinicPatientsStateUniqueIdentifier = '_clinicPatients_';

/** Describes clinic patients state fields. */
export interface DashboardClinicPatientsStateModel {
  /** Load patient list progress status. */
  loadPatientsStatus: PROGRESS_STATUSES;

  /** Last error that occurs during load patient list process. */
  lastLoadPatientsError: UnknownError;

  /** Number of patients for current filter. */
  totalPatientsCount: number;

  /** Number of pages for current filter. */
  pagesCount: number;

  /** Currently selected page. */
  currentPage: number;

  /** List of filtered patients accounts for the current page. */
  patientList: UserSharedAccountData[];

  /** Current search by name input. */
  searchByName: string;

  /** Contain current sorting by date option. */
  appliedSorting: ClinicPatientsSortRule;

  /** Contain current sorting by date option. */
  appliedFiltering: ClinicPatientsAppliedFilters;

  /** Status of the removal patient from his clinic. */
  removePatientStatus: {[patientId: string]: PROGRESS_STATUSES};

  /** The last error that occurred during the patient removal. */
  lastRemovePatientError: UnknownError;

  /** Contain grant patient access progress statuses. */
  grantAccessForPatientStatuses: {[patientId: UserSharedAccountData['uid']]: PROGRESS_STATUSES};

  /** Contain last error that occurs during grant access for a patient account process. */
  lastGrantAccessError: UnknownError;
}

/** Default values for clinic patients state initialization and reset. */
export const clinicPatientsStateDefaults: DashboardClinicPatientsStateModel = {
  loadPatientsStatus: PROGRESS_STATUSES.NOT_INITIALIZED,
  lastLoadPatientsError: null,
  totalPatientsCount: 0,
  pagesCount: 1,
  currentPage: 1,
  patientList: [],
  searchByName: null,
  appliedSorting: ClinicPatientsSortRule.UploadDateDescend,
  appliedFiltering: ClinicPatientsAppliedFilterDefault,

  removePatientStatus: {},
  lastRemovePatientError: null,

  grantAccessForPatientStatuses: {},
  lastGrantAccessError: null,
};
